import { globals } from 'config/globals';
import { Controller } from 'core/Controller';
import { MouseController } from 'app/chrome/mouse/MouseController';
import { ScrollbarController } from 'app/chrome/scrollbar/ScrollbarController';
import { InertiaDrag } from 'interaction/InertiaDrag';
import { Direction } from 'utils/motion/Direction';
import { AxisType } from 'app/enum/Geometry';
import { App } from 'core/App';
import { UIController } from 'app/views/ui/UIController';
import DelayHelper from 'utils/timers';

/** @class Controller to manage history state elements  */
export class VerticalDragController extends Controller {
	//Higher the number the less the user needs to drag to trigger tolerence:
	private readonly DIRECTION_SENSIVITY: number = 200;

	private _mouseController: MouseController;
	private _scrollbarController: ScrollbarController;
	private _uiController: UIController;

	private _active: boolean = false;
	private _throttled: boolean = false;
	private _blocked: boolean = false;

	//Libraries:
	private _inertiaDrag: InertiaDrag;
	private _direction: Direction;

	/** As a global controller init will be called on load. So set the intial state. Used when back takes to intial page  website */
	public init(): void {
		this._addInertiaDrag();
		this._direction = new Direction(this.DIRECTION_SENSIVITY);
		if (App.instance) {
			App.instance.addPreTick((delta: number) => {
			});
		}

		this._processFrame();
	}

	private _processFrame() {
	}

	public setControllers(
		mouseController: MouseController,
		scrollbarController: ScrollbarController,
		ui: UIController
	): void {
		this._mouseController = mouseController;
		this._scrollbarController = scrollbarController;
		this._uiController = ui;
	}

	public start(): void {
		if (globals.tmpApp || this._scrollbarController.isSafari || this._scrollbarController.isMac) {
			return;
		}

		this._mouseController.startVerticalScroll();
		this._active = true;
		this._inertiaDrag.setActive(true);
	}

	public stop(): void {
		this._mouseController.stopVerticalScroll();
		this._active = false;
		this._inertiaDrag.setActive(false);
	}

	/* Something to pause the */
	public pause(): void {}

	public tick(): void {
		if (this._active) {
			this._tick(1);
		}
	}

	/** Called when an interatcive element is intially interacted with.
	 *  Most likely by /library/scroll/InterativeArea.ts class on mousedown event or touchstart
	 *  Checks that then next 'direction' event triggered is horizontal
	 */
	public throttle(onMeaningfulDirection: Function): void {
	}

	public resetThrottle(): void {
		this._throttled = false;
		//Slight delay on the blocked reset:
		DelayHelper.setTimeout(() => (this._blocked = false), 100);
		this._direction.onUpdate = null;
	}

	//Private
	//-----------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------
	//-----------------------------------------------------------------------------------------

	private _addInertiaDrag(): void {
		this._inertiaDrag = new InertiaDrag(null);
		this._inertiaDrag.simulate = true;
		this._inertiaDrag.simulateSteps = 90;
		this._inertiaDrag.stepAfterRelease = false;
		this._inertiaDrag.onPress = this._onInertiaDragPress.bind(this);
		this._inertiaDrag.releaseOutside = this._onInertiaDragRelease.bind(this);
		this._inertiaDrag.onRelease = this._onInertiaDragRelease.bind(this);
	}

	private _onInertiaDragPress(): void {
		if (!this._active || globals.lastCordsFromTouch) {
			return;
		}

		this._uiController.setVerticalDragPointerDown(true);
		this._scrollbarController.setVerticalDragActive(true, this._inertiaDrag.eventType);
		this._scrollbarController.resetMovement();
		this._mouseController.setDragDown(true);
	}

	private _tick(delta: number) {
		if (!this._active || globals.lastCordsFromTouch) {
			return;
		}

		let step = this._inertiaDrag.tick(1);

		if (!step || step.y == 0 || this._mouseController.moveAxis != AxisType.VERTICAL) {
			return;
		}

		//If the drag is throttled then need to check direction for meaningful direction change:
		if (this._throttled) {
			this._direction.calculate(this._mouseController.getMouseCords());
		}

		if (!this._active || this._throttled || this._blocked) {
			return;
		}

		if (Math.abs(step.y) < 100) {
			this._scrollbarController.verticalDrag(step.y);
		}
	}


	private _onInertiaDragRelease(): void {
		if (!this._active || globals.lastCordsFromTouch) {
			return;
		}

		//Apply the flick/swipe motion based on mouse velocity
		//Only allow this is not blocked:

		this._scrollbarController.removeResidule();
		this._uiController.setVerticalDragPointerDown(false);
		this._inertiaDrag.removeResidule();

		if (!this._throttled && !this._blocked && this._mouseController.moveAxis == AxisType.VERTICAL) {
			this._scrollbarController.throwPage(this._mouseController.velocityY);
		}

		//Show the reset of the mouse:
		this._mouseController.setDragDown(false);

		//Reactive dragging after a safe interval:
		DelayHelper.setTimeout(() => this._inertiaDrag.setActive(this._active), 20);
	}

}
